<div class="residence-add-container">
  <p>Please manually add your accommodation</p>
  <input type="text" [value]="prefill" #residenceName />
  <button
    (click)="addResidence($event)"
    [disabled]="adding"
    [class.button-loading]="adding"
    [class.button-loading-disabled]="adding"
  >
    <span>Submit</span>
  </button>
</div>
